class ComponentSubscribe extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    this.addDirectEvent("change", this, this.change);

    this.selectLine(this.checkedValue("[data-subscribe-line]"));
    this.selectFrequency(this.checkedValue("[data-subscribe-frequency]"));
  }

  checkedValue(selector) {
    return this.querySelector(`${selector}:checked`)?.value;
  }

  change(event) {
    const input = event.target;

    if (input.matches("[data-subscribe-line]")) {
      this.selectLine(input.value);
    }

    if (input.matches("[data-subscribe-frequency]")) {
      this.selectFrequency(input.value);
    }
  }

  markActive(selector) {
    this.querySelectorAll(selector).forEach((input) => {
      input.closest("label").classList.toggle("state--active", input.checked);
    });
  }

  selectLine(line) {
    const panels = this.querySelectorAll("[data-subscribe-panel]");

    if (!line || panels.length === 0) {
      return;
    }

    this.markActive("[data-subscribe-line]");

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.subscribePanel !== line;
    });

    document.querySelectorAll("[data-faq-line]").forEach((faq) => {
      faq.hidden = faq.dataset.faqLine !== line;
    });

    const faqUrl = document.querySelector(`[data-faq-line="${line}"]`)?.dataset.faqUrl;

    if (faqUrl) {
      document.querySelectorAll("[data-faq-link]").forEach((link) => {
        link.href = faqUrl;
      });
    }
  }

  selectFrequency(frequency) {
    if (!frequency) {
      return;
    }

    this.markActive("[data-subscribe-frequency]");

    this.querySelectorAll("[data-subscribe-plans]").forEach((form) => {
      const plans = JSON.parse(form.dataset.subscribePlans);
      const plan = plans[frequency];
      const button = form.querySelector("[type=submit]");

      form.querySelector("[name=selling_plan]").value = plan ?? "";
      button.disabled = !plan || button.dataset.soldOut === "true";
    });
  }
}

customElements.define("component-subscribe", ComponentSubscribe);
